<template>
<div class="chapter">
<div class="inner_page">
<div id="d14be04baee4e-d1e261"><span id="pageiii">
<h1 class="book-title">HEIRS AND ASSIGNS</h1>
<h2 class="book-author">Marjorie Eccles</h2>
<p class="publisher-logo"><span class="image-centered" id="imgd1e944"><img alt="" src="OEBPS/images/9781780106915_epub_002.jpg"/></span></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106915_epub_tp.vue?9ba15816